import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const MultiLanguage = makeShortcode("MultiLanguage");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <MultiLanguage mdxType="MultiLanguage">
      <pre><code parentName="pre" {...{
          "className": "language-bash",
          "metastring": "file=npm",
          "file": "npm"
        }}>{`npm install --save posthog-js
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-bash",
          "metastring": "file=Yarn",
          "file": "Yarn"
        }}>{`yarn add posthog-js
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-bash",
          "metastring": "file=pnpm",
          "file": "pnpm"
        }}>{`pnpm add posthog-js
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-bash",
          "metastring": "file=Bun",
          "file": "Bun"
        }}>{`bun add posthog-js
`}</code></pre>
    </MultiLanguage>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      